import React from 'react';
import { ToastContainer } from 'react-toastify';
import { useDarkMode } from '../shared/hooks/useDarkMode';
import 'react-toastify/dist/ReactToastify.css';

export const Toaster: React.FC = () => {
  const { isDark } = useDarkMode();

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      role="region"
      aria-live="polite"
      aria-relevant="additions text"
      aria-label="Notifications"
      theme={isDark ? 'dark' : 'light'} // Dynamic theme based on current mode
      toastClassName={() =>
        `relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer ${
          isDark ? 'bg-xtnd-dark-800 text-xtnd-white' : 'bg-xtnd-white text-xtnd-dark'
        }`
      }
    />
  );
};
